module.exports = "<div class=\"main-container overflow-auto\">\n  <h2>Settings</h2>\n  <div class=\"content-wrapper\">\n    <div class=\"side-menu\">\n      <p-panelMenu\n        [model]=\"settingsMenuItems\"\n        [multiple]=\"false\"\n        [style]=\"{ width: '300px' }\"\n      ></p-panelMenu>\n    </div>\n    <div class=\"settings-content\">\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/main-settings/main-settings.component.html
// module id = ./src/app/main-settings/main-settings/main-settings.component.html
// module chunks = main